import styled, { css } from 'styled-components';

import { ReactComponent as Search } from '../../../assets/images/blueTheme/search.svg';
import { ReactComponent as Clear } from '../../../assets/images/blueTheme/X.svg';

export const Wrapper = styled.div`
  display: flex;
  align-items: center;
  height: 32px;
  overflow: hidden;
`;

export const IconWrapper = styled.div<{ $isExpanded: boolean }>(
  ({ theme: { spacers, admanColors }, $isExpanded }) => css`
    display: flex;
    align-items: center;
    justify-content: center;
    padding: ${spacers!.spacer02};
    border-radius: 8px;
    opacity: ${$isExpanded ? 0 : 1};
    transition: opacity ${$isExpanded ? 0 : 300}ms ease-out ${$isExpanded ? 0 : 300}ms;
    border: 1px solid transparent;

    &:hover {
      cursor: pointer;
      background-color: ${admanColors!.gray.light.bg0[2]};
    }
  `
);

export const SearchIcon = styled(Search)`
  width: 16px;
  height: 16px;
`;

export const InputWrapper = styled.div<{ $isExpanded: boolean }>(
  ({ theme: { spacers, admanColors }, $isExpanded }) => css`
    position: relative;
    display: flex;
    align-items: center;
    height: 32px;
    gap: ${spacers!.spacer02};
    border-radius: 8px;
    background: ${admanColors!.gray.light.bg0[0]};
    transition: width 300ms ease-out, padding ${$isExpanded ? 0 : 300}ms ease-out ${$isExpanded ? 0 : 100}ms;
    border: 1px solid transparent;

    ${$isExpanded
      ? css`
          width: 265px;
          border: 1px solid ${admanColors!.gray.light.bg3[1]};
          padding: 0 ${spacers!.spacer02};
        `
      : css`
          width: 0;
          border: none;
          padding: 0;
        `};
  `
);

export const Input = styled.input(
  ({ theme: { admanColors } }) => css`
    width: 100%;
    height: 100%;
    border: none;
    padding: 0;
    outline: none;
    color: ${admanColors!.gray.dark.fg[7]};
  `
);

export const SearchIndicator = styled(Search)(
  ({ theme: { admanColors } }) => css`
    width: 16px;
    height: 16px;
    flex-shrink: 0;
    fill: ${admanColors!.blue.dark.bg1[0]};

    > path {
      fill: ${admanColors!.blue.dark.bg1[0]};
    }
  `
);

export const ClearIcon = styled(Clear)(
  ({ theme: { spacers, admanColors } }) => css`
    width: 16px;
    height: 16px;
    flex-shrink: 0;
    padding-right: ${spacers!.spacer02};
    box-sizing: content-box;
    border-right: 1px solid ${admanColors!.gray.light.bg3[1]};
    cursor: pointer;
    fill: ${admanColors!.gray.light.fg1[0]};

    > path {
      fill: inherit;
    }

    &:hover {
      fill: ${admanColors!.gray.light.fg1[1]};
    }
  `
);
